module.exports = __webpack_public_path__ + "img/lv.0b1b115d.svg";